<div class="sec-title">
    <h1>Les Utilisateurs</h1>
</div>
<div><a class="btn btn-action" href="/gestion" routerLink="/gestion" role="button"><i class="bi bi-arrow-90deg-left"></i> retour à la gestion</a></div>
<ul class="editing-list list-group">
    <li class="list-group-item list-group-header">
      <div class="card">
        <div class="row">
          <div class="col-7 col-md-7">
            <h4>Liste des utilisateurs</h4>
          </div>
          <div class="col-5 col-md-5 d-flex justify-content-end align-text-bottom header-action-btn">
            <div class="col-4"><a class="btn btn-success btn-action" href="#" role="button"><i class="bi bi-plus-circle"></i> compte usager</a></div>
            <!--
            <div class="input-group mb-3">
              
                <input type="text" class="form-control" placeholder="Recherche..." aria-label="Recherche" size="400">
                <div class="input-group-append">
                  <span class="input-group-text right-action-btn"><i data-toggle="tooltip" data-placement="top" title="Recherche" class="bi bi-search"></i></span>
                </div>
            </div>
            -->
         </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-6 col-md-11">
                  <div class="row">
                    <div class="col-6 col-md-1">Actif?</div>
                    <div class="col-6 col-md-2">Vendeur</div>
                    <div class="col-6 col-md-4">Nom de l'Usager</div>
                    <div class="col-6 col-md-5">Courriel</div>
                  </div>
                </div>
                <div class="col-md-1 d-flex justify-content-end action-icons">
                  <div>Modifier</div>
                </div>
            </div>
        </div>
      </div>
    </li>
    <li class="list-group-item" *ngFor="let account of accountList; let i = index;">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-1">
                    <p class="card-title">
                      <i *ngIf="account.active === true" width="16" height="16"  class="bi bi-check-circle-fill txt-active"></i>
                      <i *ngIf="account.active !== true" width="16" height="16"  class="bi bi-x-check-circle-fill txt-inactive"></i>
                    </p>
                  </div>
                  <div class="col-md-2">
                    <ng-container>
                      <ng-container>
                        <p *ngIf="account.is_sales === true" class="card-text">
                            Vendeur
                        </p>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="col-md-4">
                    <p class="card-title card-title-main">{{account.first_name}} {{account.last_name}} </p>
                  </div>
                  <div class="col-md-5">
                    <p class="card-title card-title-main">{{account.email}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-1 d-flex justify-content-end action-icons">
                <a routerLink="../usager/{{account.account_id}}/editer" class="card-link"><button type="button" class="btn btn-outline-secondary"><i class="bi bi-pencil-square"  data-toggle="tooltip" data-placement="top" title="Modifier l'usager"></i></button></a>
              </div>
            </div>
          </div>
        </div>
      </li>
</ul>